import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`If you have an npm user account, you can convert your user account to an organization. When you convert your user account to an organization, we will:`}</p>
    <ul>
      <li parentName="ul">{`Create a new organization with the name of your user account.`}</li>
      <li parentName="ul">{`Prompt you to create a new npm user account. We recommend choosing a variation of your old user name so collaborators will recognize you. For example, if your old username was "wombat", your new username might be "wombat-new".`}</li>
      <li parentName="ul">{`Make your new npm user account an owner of your new organization.`}</li>
      <li parentName="ul">{`Add your new npm user account to a team called "Developers" in your new organization.`}</li>
      <li parentName="ul">{`Transfer packages owned by your user account to your new organization.`}</li>
      <li parentName="ul">{`Transfer your existing organization and team memberships and contributor access settings to your new user account.`}</li>
    </ul>
    <p><strong parentName="p">{`Note:`}</strong>{` Once your old user account has been converted to an organization, you will no longer be able to sign in to npm with your old user account.`}</p>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-create'].text}</>
        <>{shared['organization-create'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Below the account creation form, click `}<strong parentName="p">{`Convert`}</strong>{`.`}</p>
        <Screenshot src="/organizations/creating-and-managing-organizations/convert-from-user.png" alt="Screenshot showing the convert dialog" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Review the account conversion steps and click `}<strong parentName="p">{`Continue`}</strong>{`.`}</p>
        <Screenshot src="/organizations/creating-and-managing-organizations/convert-confirmation.png" alt="Screenshot showing the convert confirmation dialog" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the new user account creation page, in the "Username" field, type the name of your new user account, then click `}<strong parentName="p">{`Submit`}</strong>{`.`}</p>
        <Screenshot src="/organizations/creating-and-managing-organizations/convert-new-username.png" alt="Screenshot showing the convert username dialog" mdxType="Screenshot" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the plan selection page, select either the "Unlimited private packages" paid plan or the "Unlimited public packages" free plan, then click `}<strong parentName="p">{`Buy`}</strong>{` or `}<strong parentName="p">{`Create`}</strong>{`.`}</p>
        <>{shared['billing-organization-plans'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you selected to use the unlimited private packages plan, in the payment dialog, provide the email, name, address, and credit card information for the card that will be used to pay for the organization.`}</p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      